import Query from "../../core/query/query";
export class ProjectQuery extends Query{
}
